import * as psl from 'psl';

export type MEDIA_TYPE = 'IMAGE' | 'PDF' | 'VIDEO' | 'AUDIO' | 'EXTERNAL';

export const checkURLForMediaType = (
  url?: string
): { type: MEDIA_TYPE; format: string } => {
  if (!url) return undefined;
  const urlNoProtocol = extractHostname(url);
  const parsed = urlNoProtocol && psl.parse(urlNoProtocol);
  const sld = parsed && 'sld' in parsed && parsed.sld;

  const IMAGE = url.match('.(jpg|jpeg|png|gif)$');
  const PDF = url.match('.(pdf)$');
  const VIDEO = url.match('.(mp4|avi|mov|flv|mwv)$');
  const AUDIO = url.match('.(wav|mp3|m4a)$');

  if (IMAGE) {
    return { type: 'IMAGE', format: IMAGE[1].toUpperCase() };
  }
  if (PDF) {
    return { type: 'PDF', format: PDF[1].toUpperCase() };
  }
  if (VIDEO) {
    return { type: 'VIDEO', format: VIDEO[1].toUpperCase() };
  }
  if (AUDIO) {
    return { type: 'AUDIO', format: AUDIO[1].toUpperCase() };
  }
  const lowercaseSld = sld?.toLowerCase();
  switch (lowercaseSld) {
    case 'youtube':
      return { type: 'VIDEO', format: 'YouTube Video' };
    case 'youtu':
      return { type: 'VIDEO', format: 'YouTube Video' };
    case 'vimeo':
      return { type: 'VIDEO', format: 'Vimeo Video' };
    default:
      return { type: 'EXTERNAL', format: 'External Resource' };
  }
};

function extractHostname(url: string) {
  let hostname = '';
  //find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }

  //find & remove port number
  hostname = hostname.split(':')[0];
  //find & remove "?"
  hostname = hostname.split('?')[0];

  return hostname;
}
